<script>
    export let id;

    import {Link} from "svelte-routing";
    import { projects, researchers, publications } from '../data.js';
    import Fa from 'svelte-fa';
    import {faExternalLinkAlt} from '@fortawesome/free-solid-svg-icons';
    import {faOrcid} from '@fortawesome/free-brands-svg-icons';
    import {faFilePdf} from '@fortawesome/free-solid-svg-icons';

    import Tag from '../Tag.svelte';
    import ButtonMore from '../ButtonMore.svelte';
    import Publication from '../Publication.svelte';
    import ResearchersBar from '../ResearchersBar.svelte';

    $: researcher = researchers[id];

</script>

<main>
    <div class="row">
        <ResearchersBar />

        <h1 class="qualiperf">{researcher.id}</h1>

        <div class="row">
            <div class="col s12 m6 l6">
                <h2 class="qualiperf"><b>{researcher.name}</b></h2>
                <img src="/content/people/{researcher.id}.png" width="200" alt="{researcher.name}"/>
                <p>{researcher.institute}</p>
                <p>
                    {#if researcher.orcid}
                        <a target="_blank" href="https://orcid.org/{researcher.orcid}"><Fa icon={faOrcid}/></a>
                        <a target="_blank" href="https://orcid.org/{researcher.orcid}">ORCID: {researcher.orcid}</a><br />
                    {/if}
                    {#each researcher.websites as website}
                        <a target="_blank" href="{website}"><Fa icon={faExternalLinkAlt}/></a>
                        <a target="_blank" href="{website}">{website}</a><br />
                    {/each}
                </p>
                {#each researcher.tags as tag}
                    <Tag {tag}/>
                {/each}
                <h2 class="qualiperf">Curriculum vitae</h2>
                <a target="_blank" href="/content/cvs/CV_{researcher.id}.pdf"><Fa icon={faFilePdf} size="2.5x"/></a>

                <h2 class="qualiperf">QuaLiPerF Projects</h2>
                <div class="row">
                    {#each researcher.projects as pid}
                        <div class="col s12 m6 l6">
                            <b>{pid}</b> {projects[pid].title}
                        </div>
                        <div class="col s12 m6 l6">
                            <Link to="projects/{pid}">
                                <img clas="qualiperf" src="/content/icons/Icon_{pid}.png" height="100" alt="{pid}"
                                     title="More information">
                            </Link>
                        </div>
                    {/each}
                </div>

            </div>
            <div class="col s12 m6 l6">

                <h2 class="qualiperf">Selected publications</h2>
                <ul>
                    {#each researcher.publications as pid}
                        <li>
                            {#if pid in publications}
                                <Publication publication={publications[pid]} />
                            {:else}
                                {pid}
                            {/if}
                        </li>
                    {/each}
                </ul>
            </div>
        </div>
    </div>
</main>

